import { useState } from "react";
import { toast } from "sonner";
import { Trophy } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const FIELDS = [["daily_target_eur", "Obiettivo giornaliero (€ di listino)", "0.01"], ["coefficient", "Coefficiente punti (€ → punti)", "0.001"], ["incentive_pct", "Incentivo (% dei punti oltre l'obiettivo)", "0.1"]];

export const IncentiveButton = ({ company }) => {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = () => api.get(`/companies/${company.id}/incentive`).then((r) => setForm(r.data)).catch((e) => toast.error(errMsg(e)));
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/companies/${company.id}/incentive`, Object.fromEntries(FIELDS.map(([k]) => [k, Number(form[k])])));
      toast.success(`Regole produzione di ${company.legal_name} salvate`); setForm(null);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const daily = form ? Number(form.daily_target_eur) * Number(form.coefficient) : 0;
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Button size="icon" variant="ghost" className="h-7 w-7" title="Obiettivo e incentivo produzione" onClick={open} data-testid={`company-incentive-${company.code}`}><Trophy className="h-3.5 w-3.5" /></Button>
      <Dialog open={!!form} onOpenChange={(o) => !o && setForm(null)}>
        <DialogContent className="max-w-md" data-testid="incentive-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Produzione · {company.code}</DialogTitle></DialogHeader>
          {form && <div className="space-y-3">
            {FIELDS.map(([k, label, step]) => (
              <div key={k}><Label>{label}</Label><Input type="number" step={step} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`incentive-${k}`} /></div>
            ))}
            <p className="bg-muted/50 p-3 text-sm" data-testid="incentive-preview">
              Obiettivo: <b>{Math.round(daily)} punti</b> per giorno lavorativo (lun–ven, escluse festività e assenze approvate). I sabati non contano per l'incentivo. Incentivo: {form.incentive_pct}% dei punti oltre l'obiettivo del mese. Punti dei lavori di squadra divisi tra i membri.
            </p>
            <Button className="w-full" onClick={save} disabled={busy} data-testid="incentive-save">Salva</Button>
          </div>}
        </DialogContent>
      </Dialog>
    </span>
  );
};
